// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "petPopup__header-3yXYy";
var _3 = "petPopup__terms-2iJLN";
export { _1 as "__esModule", _2 as "petPopup__header", _3 as "petPopup__terms" }
export default { "__esModule": _1, "petPopup__header": _2, "petPopup__terms": _3 }
